import { AxiosResponse, CancelToken } from "axios";
import http from "../../../../shared/http";
import { ReserveRequestDto, ReserveResponseDto } from "./dtos";

export const reserve = async (
  data: ReserveRequestDto,
  cancelToken: CancelToken
): Promise<AxiosResponse<ReserveResponseDto>> => {
  return await http.post<ReserveResponseDto>(
    `/reserve`,
    {
      ...data,
    },
    { cancelToken }
  );
};
